
import Users from './Users'
const exportObj = {
    Users
}

export default exportObj